/**
 * Props for an accordion panel that stays in the DOM while collapsed, because
 * the collapse is a CSS `max-height` transition rather than `display: none`.
 *
 * `inert` removes the whole subtree from the tab order *and* the accessibility
 * tree, so keyboard users tab from one accordion header to the next instead of
 * landing on invisible filter controls, and screen readers stop announcing the
 * options of a collapsed facet (O5R-199).
 *
 * Individual controls inside these panels also carry `tabIndex={active ? 0 : -1}`
 * as a fallback for browsers without `inert` support (Safari < 15.5).
 */
export function collapsiblePanelProps(active: boolean) {
  return {
    inert: !active,
    "aria-hidden": !active
  }
}
